import { ContentSuggestResponse, isContentSuggestResponse } from '../AbstractComboBox/api/ContentSuggestResponse';
import { PagesSuggestResponse } from '../AbstractComboBox/api/PagesSuggestResponse';
import { Section } from '../AbstractComboBox/types/Section';
import { TopContentResult } from '../AbstractComboBox/types/SuggestResultTypes';

export default function getContentTopResults(
  responseData: ContentSuggestResponse | PagesSuggestResponse | undefined
): Section<TopContentResult>[] {
  if (!responseData) {
    return [];
  }
  const key = isContentSuggestResponse(responseData) ? 'content' : 'pages';
  const section = isContentSuggestResponse(responseData) ? responseData.content : responseData.pages;
  if (key && section) {
    const results = section?.topResults;
    return [
      {
        key,
        results: results?.map(TopContentResult),
      },
    ];
  }
  return [];
}
